module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form"
  }, [_c('form', {
    staticClass: "contact-form__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "contact-form__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "contact-form__input",
    class: {
      'input': true, 'contact-form__input--error': _vm.errors.has('full-name')
    },
    attrs: {
      "name": "full-name",
      "type": "text",
      "placeholder": "Full Name"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "contact-form__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('full-name')),
      expression: "errors.has('full-name')"
    }]
  }, [_vm._v("Full name is required.")])])]), _c('div', {
    staticClass: "contact-form__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/
      }),
      expression: "{required: true, regex: /^\\D?(\\d{3})\\D?\\D?(\\d{3})\\D?(\\d{4})$/}"
    }],
    staticClass: "contact-form__input",
    class: {
      'input': true, 'contact-form__input--error': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "phone",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "contact-form__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }]
  }, [_vm._v("Valid phone number is required.")])])]), _c('div', {
    staticClass: "contact-form__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "contact-form__input",
    class: {
      'input': true, 'contact-form__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "contact-form__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }]
  }, [_vm._v("Valid email is required.")])])]), _c('div', {
    staticClass: "contact-form__group"
  }, [_c('p', [_vm._v("First Time Patient?")]), _c('div', {
    staticClass: "contact-form__radio-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPatient),
      expression: "newPatient"
    }],
    staticClass: "contact-form__input--radio",
    attrs: {
      "name": "newPatient",
      "value": "Yes",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPatient, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.newPatient = "Yes"
      }
    }
  }), _c('span', {
    staticClass: "contact-form__radio-overlay"
  }), _c('label', {
    staticClass: "contact-form__label"
  }, [_vm._v("Yes")])]), _c('div', {
    staticClass: "contact-form__radio-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPatient),
      expression: "newPatient"
    }],
    staticClass: "contact-form__input--radio",
    attrs: {
      "name": "newPatient",
      "value": "No",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPatient, "No")
    },
    on: {
      "change": function($event) {
        _vm.newPatient = "No"
      }
    }
  }), _c('span', {
    staticClass: "contact-form__radio-overlay"
  }), _c('label', {
    staticClass: "contact-form__label"
  }, [_vm._v("No")])])]), _c('div', {
    staticClass: "contact-form__group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact-form__textarea",
    class: {
      'contact-form__textarea--error': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "textarea",
      "rows": "4",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "contact-form__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }]
  }, [_vm._v("Send us a message!")])])]), _c('div', {
    staticClass: "contact-form__group agree"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreeToTerms),
      expression: "agreeToTerms"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact-form__checkbox",
    class: {
      'contact-form__checkbox--error': _vm.errors.has('agreeToTerms')
    },
    attrs: {
      "type": "checkbox",
      "name": "agreeToTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeToTerms) ? _vm._i(_vm.agreeToTerms, null) > -1 : (_vm.agreeToTerms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agreeToTerms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreeToTerms = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreeToTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreeToTerms = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "contact-form__label",
    class: {
      'contact-form__checkbox--error': _vm.errors.has('agreeToTerms')
    }
  }, [_vm._v("I agree to receive marketing and customer service emails and text messages from Mattiacio Orthodontics. Msg/data rates may apply. Reply STOP to unsubscribe.")])]), _c('div', {
    staticClass: "contact-form__button-group"
  }, [_c('button', {
    staticClass: "contact-form__submit-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.formSubmitted
    }
  }, [_c('span', [_vm._v("Submit")])]), (_vm.formSubmitted) ? _c('div', {
    staticClass: "contact-form__spinner"
  }, [_c('span', [_vm._v("Sending")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-748c5946","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/form/form.pug
// module id = 723
// module chunks = 1